import { SingleProduct as CatalogSingleProduct } from './SingleProduct';

export default CatalogSingleProduct;
